<div class="mail-tab">

  <!-- ─── List side ─── -->
  <div class="mail-list">

    <div class="mail-toolbar">
      <div class="mail-search">
        <mat-icon>search</mat-icon>
        <input type="text" [formControl]="searchControl" placeholder="Search mail" aria-label="Search mail">
        <button mat-icon-button *ngIf="searchControl.value" matTooltip="Clear" aria-label="Clear mail search" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <button mat-icon-button matTooltip="Refresh" aria-label="Refresh mail" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <!-- Folder pills are hidden during a search, which spans the whole mailbox rather than one folder -->
    <nav class="mail-folders" *ngIf="!searching">
      <button *ngFor="let folder of folders"
              class="mail-folder-pill"
              [class.mail-folder-pill--active]="activeFolder === folder.key"
              [attr.aria-pressed]="activeFolder === folder.key"
              (click)="selectFolder(folder.key)">
        <mat-icon>{{ folder.icon }}</mat-icon>
        <span>{{ folder.label }}</span>
      </button>
    </nav>

    <p class="mail-search-scope" *ngIf="searching">Searching your whole mailbox</p>

    <div class="mail-loading" *ngIf="loading">
      <mat-spinner diameter="26"></mat-spinner>
    </div>

    <div class="mail-empty" *ngIf="!loading && messages.length === 0">
      <mat-icon>mail_outline</mat-icon>
      <p>{{ searching ? 'No messages match that search.' : 'Nothing in this folder.' }}</p>
    </div>

    <ul class="mail-items" *ngIf="!loading && messages.length > 0">
      <li *ngFor="let message of messages; trackBy: trackById"
          class="mail-item"
          [class.mail-item--unread]="!message.isRead"
          [class.mail-item--selected]="selected?.id === message.id"
          tabindex="0"
          (click)="openMessage(message)"
          (keydown.enter)="openMessage(message)">
        <div class="mail-item__row">
          <span class="mail-item__from">{{ message.fromName }}</span>
          <span class="mail-item__date">{{ message.receivedDateTime | date:'d MMM' }}</span>
        </div>
        <div class="mail-item__subject">
          <mat-icon *ngIf="message.flagged" class="mail-item__flag">flag</mat-icon>
          <mat-icon *ngIf="message.hasAttachments" class="mail-item__clip">attach_file</mat-icon>
          {{ message.subject }}
        </div>
        <div class="mail-item__preview">{{ message.preview }}</div>
      </li>
    </ul>
  </div>

  <!-- ─── Reading pane ─── -->
  <div class="mail-reader" *ngIf="selected || loadingDetail">

    <div class="mail-loading" *ngIf="loadingDetail">
      <mat-spinner diameter="26"></mat-spinner>
    </div>

    <ng-container *ngIf="selected && !loadingDetail">
      <div class="mail-reader__head">
        <div class="mail-reader__title">
          <h3>{{ selected.subject }}</h3>
          <p class="mail-reader__meta">
            <strong>{{ selected.fromName }}</strong>
            <span *ngIf="selected.fromAddress"> &lt;{{ selected.fromAddress }}&gt;</span>
            · {{ selected.receivedDateTime | date:'d MMM y, HH:mm' }}
          </p>
          <p class="mail-reader__meta" *ngIf="selected.to.length">
            To: <span *ngFor="let r of selected.to; let last = last">{{ r.name || r.address }}{{ last ? '' : ', ' }}</span>
          </p>
        </div>
        <button mat-icon-button matTooltip="Close" aria-label="Close message" (click)="closeReadingPane()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="mail-reader__actions">
        <button mat-stroked-button (click)="openInOutlook(selected.id)">
          <mat-icon>open_in_new</mat-icon>
          <span>Open in Outlook</span>
        </button>
        <button mat-button (click)="replyInOutlook(selected)">
          <mat-icon>reply</mat-icon>
          <span>Reply</span>
        </button>
        <button mat-button (click)="forwardInOutlook(selected)">
          <mat-icon>forward</mat-icon>
          <span>Forward</span>
        </button>
      </div>

      <div class="mail-reader__attachments" *ngIf="selected.attachments.length">
        <mat-icon>attach_file</mat-icon>
        <span *ngFor="let a of selected.attachments; let last = last" class="mail-reader__attachment">
          {{ a.name }}{{ last ? '' : ',' }}
        </span>
        <span class="mail-reader__attachment-note">— open in Outlook to download</span>
      </div>

      <!-- Sandboxed: no allow-scripts and no allow-same-origin, so the body cannot reach this page -->
      <iframe class="mail-reader__body"
              sandbox=""
              referrerpolicy="no-referrer"
              [srcdoc]="safeBody"
              title="Message body"></iframe>

      <p class="mail-reader__footer">
        Replies open in Outlook — Klidi has read-only access to your mailbox.
      </p>
    </ng-container>
  </div>

</div>
